module.exports = __webpack_public_path__ + "static/img/bg.722dedc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/news2/bg.jpg
// module id = LSJt
// module chunks = 7